// ClubFilters.js — the All / this season / Former toggle and the club search
// box, shared by /clubs and /all-time-table.

import React from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { BRAND } from "../../theme";

export function StatusFilter({ value, onChange, counts, currentLabel }) {
  return (
    <Box role="radiogroup" aria-label="Show clubs" sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {[
        ["all", "All clubs"],
        ["current", currentLabel],
        ["former", "Former"],
      ].map(([v, label]) => {
        const active = value === v;
        return (
          <Box
            key={v}
            component="button"
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(v)}
            sx={{
              font: "inherit",
              cursor: "pointer",
              px: 1.75,
              py: 0.75,
              borderRadius: 999,
              fontSize: 13.5,
              fontWeight: 700,
              color: active ? "#fff" : BRAND.textSecondary,
              background: active ? BRAND.gradient : "rgba(255,255,255,0.04)",
              border: `1px solid ${active ? "transparent" : "rgba(255,255,255,0.14)"}`,
              "&:hover": { color: "#fff" },
              "&:focus-visible": { outline: `2px solid ${BRAND.cyan}`, outlineOffset: 2 },
            }}
          >
            {label}
            <Box component="span" sx={{ ml: 0.75, opacity: 0.75, fontWeight: 600 }}>
              {counts[v]}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export function ClubSearch({ id, value, onChange, width = 220 }) {
  return (
    <TextField
      id={id}
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search clubs"
      inputProps={{ "aria-label": "Search clubs" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: BRAND.cyan, fontSize: 20 }} />
          </InputAdornment>
        ),
      }}
      sx={{
        ml: { sm: "auto" },
        width: { xs: "100%", sm: width },
        "& .MuiOutlinedInput-root": {
          borderRadius: 999,
          background: "rgba(20,20,26,0.7)",
          "& fieldset": { borderColor: "rgba(255,255,255,0.14)" },
          "&:hover fieldset, &.Mui-focused fieldset": { borderColor: BRAND.cyan },
        },
        "& input": { color: "#fff", fontSize: 14 },
      }}
    />
  );
}
